import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useI18n } from '#/i18n/hooks/useI18n';
import { userDashboardApplicationHistoryPath } from '#/modules/userDashboard/routing/userDashboard.paths';
import { trackClicked } from '#/utils/analytics/track/trackClicked';
import { trackEventOnce } from '#/utils/analytics/track/trackEventOnce';
import { trackDisplayToast } from '#/utils/analytics/track/trackToast';
import { dismissToast, showToast } from '#/zustand-stores/toastsStore';

export function useShowMarkAsAppliedToast() {
  const { i18n } = useI18n();
  const navigate = useNavigate();

  const showMarkAppliedToast = useCallback(() => {
    trackDisplayToast({
      type: 'success_mark_applied',
      current_page_url: window.location.href,
    });

    showToast({
      actions: [
        {
          label: i18n('See All'),
          onClick: () => {
            trackClicked('Action Toast', {
              type: 'success_mark_applied',
              current_page_url: window.location.href,
            });
            dismissToast('success-mark-applied');
            void navigate(userDashboardApplicationHistoryPath.with({}));
          },
          type: 'button',
        },
      ],
      headline: i18n("You've marked this listing as applied"),
      onDismiss: () => {
        trackEventOnce('Dismissed: Action Toast', {
          type: 'success_mark_applied',
          current_page_url: window.location.href,
        });
      },

      dismissible: true,
      durationMs: 15_000,
      id: 'success-mark-applied',
      variant: 'info',
    });
  }, [navigate, i18n]);

  return { showMarkAppliedToast };
}
